import { ArrowRight, Check } from 'lucide-react';
import { Link } from 'react-router-dom';
import { Button, ScrollReveal, Surface } from '@agenda-facil/ui';

interface ContentPageProps {
  eyebrow: string;
  title: string;
  intro: string;
  items: Array<{ title: string; text: string }>;
}

export function ContentPage({ eyebrow, title, intro, items }: ContentPageProps) {
  return (
    <>
      <section className="marketing-grid border-b border-[var(--border)] py-20 sm:py-28">
        <ScrollReveal variant="fade-up" className="page-shell">
          <span className="eyebrow">{eyebrow}</span>
          <h1 className="display text-balance mt-6 max-w-4xl text-5xl leading-[1.02] sm:text-7xl">
            {title}
          </h1>
          <p className="mt-7 max-w-2xl text-lg leading-8 text-[var(--muted-foreground)]">
            {intro}
          </p>
        </ScrollReveal>
      </section>
      <section className="py-16 sm:py-24">
        <div className="page-shell grid gap-4 md:grid-cols-2">
          {items.map((item, index) => (
            <ScrollReveal key={item.title} variant="scale" delay={(index + 1) * 100}>
              <Surface className="h-full p-7 sm:p-9">
                <span className="grid size-9 place-items-center rounded-full bg-[var(--success-soft)] text-[var(--success)]">
                  <Check size={17} />
                </span>
                <h2 className="mt-8 text-xl font-extrabold">{item.title}</h2>
                <p className="mt-3 leading-7 text-[var(--muted-foreground)]">{item.text}</p>
              </Surface>
            </ScrollReveal>
          ))}
        </div>
      </section>
      <section className="pb-20 sm:pb-28">
        <ScrollReveal variant="scale" className="page-shell">
          <div className="flex flex-col items-start justify-between gap-6 rounded-[28px] bg-[var(--brand-strong)] p-8 text-white sm:flex-row sm:items-center sm:p-10">
            <div>
              <h2 className="display text-3xl">Pronto para colocar a casa em ordem?</h2>
              <p className="mt-2 text-sm text-white/60">Seu teste de 14 dias começa sem cartão.</p>
            </div>
            <Button asChild>
              <Link to="/cadastro">
                Começar agora <ArrowRight size={17} />
              </Link>
            </Button>
          </div>
        </ScrollReveal>
      </section>
    </>
  );
}

